import React, { useCallback, useEffect, useState } from "react";
import api from "../../api";
import { motion } from "framer-motion";
import { Sparklines, SparklinesLine } from "react-sparklines";

import "../../styles/Headlines.css";

const indices = [
  { label: "NASDAQ", symbol: "^IXIC" },
  { label: "S&P 500", symbol: "^GSPC" },
  { label: "EUR/USD", symbol: "EURUSD=X" },
  { label: "Taux 10 ans US", symbol: "^TNX" },
  { label: "Gold", symbol: "GC=F" },
  { label: "WTI", symbol: "CL=F" },
];

const Headlines = ({ className = "" }) => {
  const [quotes, setQuotes] = useState([]);
  const [error, setError] = useState("");

  const fetchQuotes = useCallback(async () => {
    try {
      const response = await api.get("/headlines");
      setQuotes(response.data);
      setError("");
    } catch (err) {
      console.error("Erreur chargement des cotations", err);
      setError("Impossible de charger les données de marché.");
    }
  }, []);

  useEffect(() => {
    fetchQuotes();
    const interval = setInterval(fetchQuotes, 300000);

    return () => clearInterval(interval);
  }, [fetchQuotes]);

  const getDataFor = (symbol) => quotes.find((quote) => quote.symbol === symbol);

  return (
    <section className={`headlines ${className}`.trim()}>
      <div className="headlines__content">
        <header className="headlines__header">
          <h2 className="headlines__title">Bloomberg Terminal — Live Quotes</h2>
          <img
            src="/assets/bloomberg-logo.jpg"
            alt="Bloomberg"
            className="headlines__logo"
          />
        </header>

        {error ? (
          <p className="headlines__error">{error}</p>
        ) : (
          <div className="headlines__grid">
            {indices.map((index, i) => {
              const data = getDataFor(index.symbol);
              const change = data?.regularMarketChangePercent?.toFixed(2);
              const sparkData = Array.from(
                { length: 10 },
                () => (data?.regularMarketPrice || 0) + (Math.random() - 0.5) * 2,
              );

              const color =
                change > 0
                  ? "text-success-400"
                  : change < 0
                    ? "text-danger-500"
                    : "text-warning-300";
              const lineColor =
                change > 0 ? "#22c55e" : change < 0 ? "#ef4444" : "#eab308";

              return (
                <motion.article
                  key={index.symbol}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.1 }}
                  className="headlines__quote"
                >
                  <div className="headlines__quote-row">
                    <div className="headlines__value-group">
                      <div className="headlines__label">
                        {index.label} <span className="headlines__ticker">{index.symbol}</span>
                      </div>
                      <div className="headlines__price">
                        {data?.regularMarketPrice?.toLocaleString() || "--"}
                      </div>
                    </div>
                    <div className={`headlines__change ${color}`}>
                      {change ? `${change}%` : "--"}
                    </div>
                  </div>

                  <div className="headlines__sparkline" aria-hidden="true">
                    <Sparklines data={sparkData} limit={10} width={64} height={16}>
                      <SparklinesLine
                        color={lineColor}
                        style={{ fill: "none", strokeWidth: 1.5 }}
                      />
                    </Sparklines>
                  </div>
                </motion.article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Headlines;
